import { h } from "@stencil/core";
export class BbgLanguageSelector {
  constructor() {
    /** Optional label */
    this.label = "";
    /** The id of the select component */
    this.dropdownId = "language-dropdown";
    /** The list of options to be passed to the dropdown component */
    this.dropdownItemList = [];
  }
  componentWillRender() {
    for (const element of this.languageList) {
      this.dropdownItemList.push({ value: element.locale, option: element.label });
    }
  }
  render() {
    const languageSelectorCssClasses = {
      "m-language-selector": true,
      "m-language-selector--no-label": this.label ? false : true,
    };
    return (h("div", { class: languageSelectorCssClasses }, h("bbg-link", { icon: "globe" }, this.label), h("bbg-dropdown", { "dropdown-id": this.dropdownId, "is-dynamic-width": "false", "aria-label": this.ariaLabel, onOptionSelected: e => this.languageSelectHandler(e), optionsList: this.dropdownItemList, "default-value": this.defaultLanguage })));
  }
  languageSelectHandler(lang) {
    this.languageSelected.emit(lang.detail);
  }
  static get is() { return "bbg-language-selector"; }
  static get originalStyleUrls() {
    return {
      "$": ["bbg-language-selector.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["bbg-language-selector.css"]
    };
  }
  static get properties() {
    return {
      "label": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Optional label"
        },
        "attribute": "label",
        "reflect": false,
        "defaultValue": "\"\""
      },
      "ariaLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The HTML aria-label attribute"
        },
        "attribute": "aria-label",
        "reflect": false
      },
      "dropdownId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The id of the select component"
        },
        "attribute": "dropdown-id",
        "reflect": false,
        "defaultValue": "\"language-dropdown\""
      },
      "languageList": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "{ locale: string; label: string }[]",
          "resolved": "{ locale: string; label: string; }[]",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The list of available languages"
        }
      },
      "defaultLanguage": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The default selected language"
        },
        "attribute": "default-language",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "dropdownItemList": {}
    };
  }
  static get events() {
    return [{
        "method": "languageSelected",
        "name": "languageSelected",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": "This event will be triggered by a language selection"
        },
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        }
      }];
  }
}
